class CartDrawer extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('.drawer-panel');
    document.addEventListener('click', event => {
      if (event.target.closest('[data-cart-open]')) this.open();
      if (event.target.closest('[data-cart-close]')) this.close();
      const remove = event.target.closest('[data-remove-line]');
      if (remove) this.change(Number(remove.dataset.removeLine), 0);
      const change = event.target.closest('[data-change-line]');
      if (change) this.change(Number(change.dataset.changeLine), Math.max(0, Number(change.dataset.quantity)));
      const add = event.target.closest('[data-drawer-add]');
      if (add) this.add(Number(add.dataset.drawerAdd));
    });
    document.addEventListener('change', event => {
      const input = event.target.closest('[data-line-quantity]');
      if (input) this.change(Number(input.dataset.lineQuantity), Math.max(0, Number(input.value) || 0));
    });
    document.addEventListener('keydown', event => { if (event.key === 'Escape') this.close(); });
    document.addEventListener('cart:refresh', () => this.refresh());
  }

  open() { this.classList.add('is-open'); this.setAttribute('aria-hidden', 'false'); document.body.classList.add('drawer-open'); this.panel.focus(); UltraDisco.push('view_cart'); }
  close() { this.classList.remove('is-open'); this.setAttribute('aria-hidden', 'true'); document.body.classList.remove('drawer-open'); }

  async refresh(open = false) {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}?section_id=cart-drawer`);
      if (!response.ok) throw new Error();
      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const fresh = documentFragment.querySelector('cart-drawer');
      this.innerHTML = fresh.innerHTML;
      this.panel = this.querySelector('.drawer-panel');
      document.querySelectorAll('[data-cart-count]').forEach(element => element.textContent = this.querySelector('[data-count-value]')?.value || 0);
      if (open) this.open();
    } catch (error) { this.status('Impossibile aggiornare il carrello. Riprova.'); }
  }

  async change(line, quantity) {
    try {
      const response = await fetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({line, quantity})});
      if (!response.ok) throw new Error();
      const cart = await response.json();
      if (quantity === 0) UltraDisco.push('remove_from_cart');
      document.dispatchEvent(new CustomEvent('cart:updated', {detail: cart}));
      await this.refresh();
    } catch (error) { this.status('Aggiornamento non riuscito.'); }
  }

  async add(id) {
    if (!id) return;
    try {
      const response = await fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id, quantity: 1}]})});
      if (!response.ok) throw new Error();
      UltraDisco.push('select_cross_sell');
      const cart = await fetch('/cart.js').then(result => result.json());
      document.dispatchEvent(new CustomEvent('cart:updated', {detail: cart}));
      await this.refresh(true);
    } catch (error) { this.status('Prodotto non disponibile.'); }
  }

  status(message) { const element = document.querySelector('#CartStatus'); if (element) element.textContent = message; }
}

customElements.define('cart-drawer', CartDrawer);

document.addEventListener('submit', async event => {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form || form.dataset.ajax === 'false') return;
  event.preventDefault();
  const button = form.querySelector('[type="submit"]') || document.querySelector(`[form="${form.id}"]`);
  button?.setAttribute('disabled', '');
  try {
    const response = await fetch('/cart/add.js', {method: 'POST', headers: {Accept: 'application/json'}, body: new FormData(form)});
    if (!response.ok) throw new Error((await response.json()).description);
    UltraDisco.push('add_to_cart');
    const cart = await fetch('/cart.js').then(result => result.json());
    document.dispatchEvent(new CustomEvent('cart:updated', {detail: cart}));
    await document.querySelector('cart-drawer')?.refresh(true);
  } catch (error) {
    document.querySelector('#CartStatus').textContent = error.message || 'Aggiunta non riuscita.';
  } finally { button?.removeAttribute('disabled'); }
});
